import axios from 'axios';
import myaxios from "./OaHttp";
import AppConfig from "../../../../config/AppConfig";

function getBaseURL() {
  // return process.env.NODE_ENV === "development" ? 'http://flow123456.com' : 'http://flow.gdzawy.com:9000'
  return process.env.NODE_ENV === AppConfig.flow_server
}

function getFlowBaseURL() {
  return AppConfig.flow_server
}

function getPreBaseURL() {
  return process.env.NODE_ENV === AppConfig.erp_server
}

const instance = axios.create({
  baseURL: getBaseURL() //+ '/contract/'
});

const ErrorResponse = {code: 400, msg: '网络错误'}

instance.interceptors.request.use(function (config) {
  if(!config.params) config.params = {}
  config.params.login = localStorage.getItem('login')
  config.params.token = localStorage.getItem('token')
  return config;
});

function DateFormat(date) {
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let sdate = ("0" + date.getDate()).slice(-2);
  return year + '-' + month + '-' + sdate
}

function get(url, data, callback) {
  instance.get(url, {params: data}).then(resp => {
    callback(resp.data)
  }).catch(error => callback(ErrorResponse))
}

function post(url, data, callback) {
  instance.post(url, data).then(resp => {
    callback(resp.data)
  }).catch(error => callback(ErrorResponse))
}
export default class Http {
  static getFlowBaseURL(){
    return getFlowBaseURL();
  }
  static getPreBaseURL(){
    return getPreBaseURL();
  }
  static getBaseURL(){
    return getBaseURL()
  }
  static get(url, data, callback){
    get(url, data, callback)
  }
  static post(url, data, callback){
    post(url, data, callback)
  }
  static uploadFile(callback){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      let formData = new FormData();
      formData.append("file",this.files[0]);
      axios.post(getBaseURL()+'/contract/contract/uploadFile',formData).then(res=>{
        if(res){
          typeof callback==="function"&&callback(res.data.data.path)
        }
      },err=>{

      })

      upload.onchange=undefined;

    }

  }

  static uploadFile(callback){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {

      let formData = new FormData();
      formData.append("user_file",this.files[0]);
      post(getPreBaseURL()+'/oa/PreUserInfo/importUser',formData,res=>{
        if(res){
          // typeof callback==="function"&&callback(res.data.data.path)
          typeof callback==="function"&&callback(res)
        }
      })
      upload.onchange=undefined;

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Oa/common/OaHttp.js